<template>
    <div>
        <div v-for="(item, index) in items" class="card card-dark border-dark mb-4">
            <div class="card-body">
                <div class="row">
                    <div class="col-sm-4 text-center">
                        <img class="img-fluid" :src="item.image" alt="">
                    </div>
                    <div class="col-sm-8">
                        <h4 class="text-primary">{{ item.title }}
                            <small class="text-light pl-2">({{ item.year }})</small>
                        </h4>
                        <div v-html="item.description"></div>
                        <button type="button" class="btn btn-outline-primary" @click="showAlbumPreview(index)">
                            {{ 'album.'+(item.isFree ? 'download' : 'listen_buy') | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <vue-modal ref="albumPreviewModal"
                   :show-header="false"
                   :show-footer="false"
                   :centered="true">
            <button slot="header"
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>

            <div v-if="hasCurrentPreview"
                 slot="body"
                 v-html="currentPreviewItem.embed"></div>
        </vue-modal>
    </div>
</template>

<script>
    import VueModal from './Modal'

    export default {
        data() {
            return {
                items: [],
                currentPreviewIndex: -1
            }
        },
        computed: {
            hasCurrentPreview() {
                return this.items.length > 0 && this.currentPreviewIndex !== -1
            },
            currentPreviewItem() {
                return this.hasCurrentPreview ? this.items[this.currentPreviewIndex] : null
            }
        },
        components: {
            'vue-modal': VueModal
        },
        created() {
            this.loadItems()
        },
        mounted() {
            $(this.$refs.albumPreviewModal.$el).on('hidden.bs.modal', function () {
                // Stopping music if any.
                const iFrame = this.querySelector('iframe');
                const soundCloudPlayer = SC.Widget(iFrame);
                soundCloudPlayer.pause();
            })
        },
        methods: {
            loadItems() {
                axios.get('/api/album')
                    .then(response => this.items = response.data.data)
                    .catch(error => console.error(error))
            },
            showAlbumPreview(index) {
                this.currentPreviewIndex = index;
                this.$refs.albumPreviewModal.show();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/MusicAlbums.vue